import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { NumOrdersOption } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  emptyDateSubconditionState,
  numOrdersFromModel,
  validateNumOrdersCondition,
  type NumOrdersState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";
import {
  getDateSubconditionSuffix,
  toModelDateSubcondition,
} from "./date-subcondition";

export const NUM_ORDERS = (
  Details: React.ComponentType<ConditionTypeDetailsProps<NumOrdersState>>,
): ConditionType<NumOrdersState, Condition.NumOrders> => ({
  name: CONDITION_NAMES[Condition.NUM_ORDERS],
  description(state) {
    if (!state.orderOption) {
      return t("The total number of orders this customer has placed");
    }

    const description =
      state.orderOption === NumOrdersOption.LESS_THAN
        ? t("Number of orders less than {{value}}", { value: state.numOrders })
        : t("Number of orders greater than {{value}}", {
            value: state.numOrders,
          });

    return description + getDateSubconditionSuffix(state.dateSubcondition);
  },
  Details(props: ConditionTypeDetailsProps<NumOrdersState>) {
    return React.createElement(Details, props);
  },
  empty: {
    numOrders: (0).toFixed(0),
    orderOption: null,
    dateSubcondition: emptyDateSubconditionState,
  },
  fromModel(model) {
    return numOrdersFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.NUM_ORDERS,
      numOrders: +state.numOrders,
      numOrdersOption: state.orderOption,
      // Use only dateSubcondition going forward
      dateSubcondition: toModelDateSubcondition(state.dateSubcondition),
    };
  },
  valid(state) {
    return validateNumOrdersCondition(state).valid;
  },
});
